"use strict";require('@ebay/skin/progress-bar');